import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import apiClient from '@/api/client'
import { useToast } from '@/hooks/use-toast'
import { describeApiError } from '@/lib/apiError'

/**
 * Build (or reopen) the kit for a suggestion or calendar moment and go to
 * it. The backend is idempotent per source, so a double click lands on the
 * same kit. Writing the copy can take a few seconds when Claude is on.
 */
export function useBuildKit() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const { toast } = useToast()
  return useMutation({
    mutationFn: (source: { suggestion_id?: string; occurrence_id?: string }) => apiClient.createMarketingKit(source),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: ['marketing', 'home'] })
      queryClient.invalidateQueries({ queryKey: ['marketing', 'suggestions'] })
      queryClient.invalidateQueries({ queryKey: ['marketing', 'calendar'] })
      queryClient.invalidateQueries({ queryKey: ['marketing', 'kits'] })
      if (res.data?.id) navigate({ to: '/admin/marketing/kits', search: { kit: res.data.id } })
    },
    onError: (err) => toast({ title: 'Could not build the kit', description: describeApiError(err).message, variant: 'destructive' }),
  })
}
